import MagnetDetailsTabs from "./Tabs";

function MagnetDetails() {
  return (
    <div className="py-5 pl-0 pr-2">
      <MagnetDetailsTabs />
    </div>
  );
}
export default MagnetDetails;
